import * as React from 'react';
import styled from 'styled-components';
import { TextBlock } from 'bench-internal-theme';

const CategoryHeaderText = styled(TextBlock).attrs(() => ({
  styleType: 'title',
}))`
  padding: 24px 0 8px;
  text-overflow: ellipsis;
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
`;

const CategoryHeaderButton = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;

  &:active {
    outline: none;
    border: none;
    box-shadow: none;
    -webkit-box-shadow: none;
  }
`;

type LedgerCategoryHeaderProps = {
  onClick: () => void;
};

export const LedgerCategoryHeader = ({
  children,
  onClick,
}: React.PropsWithChildren<LedgerCategoryHeaderProps>): React.ReactElement => (
  <CategoryHeaderButton onClick={onClick}>
    <CategoryHeaderText>{children}</CategoryHeaderText>
  </CategoryHeaderButton>
);
